import * as React from "react";
const SvgFiRrLinkHorizontalSlash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-link-horizontal-slash_svg__a)">
      <path
        fill="#062147"
        d="M3.771 13.38a1 1 0 0 1-1.407.134A6.48 6.48 0 0 1 .001 8.5c0-.602.083-1.198.245-1.772a.996.996 0 0 1 1.234-.689c.532.15.84.702.69 1.234a4.52 4.52 0 0 0 1.468 4.7 1 1 0 0 1 .134 1.408M15.001 20h-2.5a4.506 4.506 0 0 1-4.01-6.545 1.001 1.001 0 0 0-1.783-.91A6.5 6.5 0 0 0 6 15.5c0 3.584 2.916 6.5 6.5 6.5H15a1 1 0 1 0 0-2zm8.706 2.293a.999.999 0 1 1-1.414 1.414l-22-22A.999.999 0 1 1 1.707.293L3.94 2.525A6.5 6.5 0 0 1 6.5 2h5C15.084 2 18 4.916 18 8.5a6.52 6.52 0 0 1-2.766 5.32l5.141 5.141A4.49 4.49 0 0 0 22 15.501c0-1.35-.597-2.614-1.637-3.473a1 1 0 0 1 1.273-1.543A6.48 6.48 0 0 1 24 15.5a6.48 6.48 0 0 1-2.206 4.88zM5.52 4.106l5.154 5.154A6.5 6.5 0 0 1 12.5 9a1 1 0 1 1 0 2h-.085l1.374 1.374A4.51 4.51 0 0 0 16 8.5C16 6.02 13.981 4 11.5 4h-5q-.503.001-.98.107"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-link-horizontal-slash_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLinkHorizontalSlash;
